import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "how",
  class: "pt-80px pb-50px <800:pb-10px <lg:pt-50px"
}
const _hoisted_2 = { class: "flex -ml-50px <800:hidden items-center <lg:pb-20px <800:pb-0 transform <1200:translate-y-30px" }
const _hoisted_3 = { class: "flex mx-auto <sm:flex-col max-w-1440px justify-around <sm:w-full <sm:max-w-460px <sm:px-50px <sm:-mt-60px" }
const _hoisted_4 = { class: "<850:flex <sm:hidden <lg:hidden xl:hidden flex justify-around" }
const _hoisted_5 = { class: "800:hidden flex justify-around pt-50px" }
const _hoisted_6 = { class: "inline-flex px-50px items-center mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rotating_badge = _resolveComponent("rotating-badge")!
  const _component_flying_span = _resolveComponent("flying-span")!
  const _component_accent_button = _resolveComponent("accent-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_central_block = _resolveComponent("central-block")!
  const _component_the_how_section_step = _resolveComponent("the-how-section-step")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_central_block, {
      title: "Как работаем",
      swap_sm: "",
      image: require('@/assets/img/img_3_step_bg.jpg'),
      subtitle: "Прозрачно и удобно"
    }, {
      centr_content: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "p-80px <1200:pt-40px <1100:pt-30px <1100:pl-60px <800:pt-20px pr-0 <lg:p-40px text-22px leading-none space-y-10px <sm:p-0 <lg:text-14px <lg:leading-18px" }, [
          _createElementVNode("div", null, "— легкая регистрация в кабинете"),
          _createElementVNode("div", null, "— быстрая проверка документов"),
          _createElementVNode("div", null, "— персональный менеджер для помощи"),
          _createElementVNode("div", null, "— бонусные мотивации от площадки и банков"),
          _createElementVNode("div", null, "— полностью электронный документооборот")
        ], -1)
      ])),
      abs_content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_flying_span, {
            timeout: 600,
            block: "",
            left: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_rotating_badge, { class: "<lg:w-140px <lg:h-140px" })
            ]),
            _: 1
          }),
          _createVNode(_component_flying_span, {
            timeout: 0,
            block: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "ml-30px",
                to: "/application"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_accent_button, { class: "<lg:text-20px" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Стать агентом")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["image"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_how_section_step, {
        num: 1,
        title: "Заключаем договор"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("все онлайн, и занимает не более 15 минут")
        ])),
        _: 1
      }),
      _createVNode(_component_the_how_section_step, {
        num: 2,
        title: "Приводите клиентов"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("нужно лишь согласие клиента, и его контакты")
        ])),
        _: 1
      }),
      _createVNode(_component_the_how_section_step, {
        class: "<850:hidden <sm:block <lg:block <xl:hidden",
        num: 3,
        active: "",
        title: "Получаете деньги"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("за те продукты что клиент оформил в банке")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_how_section_step, {
        class: "xl:hidden w-1/2",
        num: 3,
        active: "",
        title: "Получаете деньги"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("за те продукты что клиент оформил в банке")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_flying_span, {
          timeout: 0,
          block: "",
          left: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_rotating_badge, { class: "<800:w-140px <800:h-140px" })
          ]),
          _: 1
        }),
        _createVNode(_component_flying_span, {
          timeout: 0,
          block: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "ml-30px",
              to: "/application"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_accent_button, { class: "<lg:text-20px" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Стать агентом")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}